import { Fancybox } from "@fancyapps/ui";

import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Make globally available for legacy code
window.Fancybox = Fancybox;

// Custom configuration (migrated from fancybox-custom.js)
// In v6, options are passed to bind() rather than setting defaults
Fancybox.bind("[data-fancybox]", {
  // Disable URL hash changes
  Hash: false,
  // Custom styling via CSS variables
  mainStyle: {
    "--f-toolbar-padding": "2px",
  },
  // Close existing instances when opening new one
  closeExisting: true,
  // Toolbar configuration - in v6 this goes in Carousel options
  Carousel: {
    Toolbar: {
      absolute: false,
      display: {
        left: [],
        middle: ["counter"],
        right: ["toggle1to1", "fullscreen", "download", "thumbs", "close"],
      },
    },
  },
});
